import prioritizer from '../prioritizer';
import type { SubscriptionType } from '../types/subscription';

function getLowestPackage<T extends { available?: boolean }, P extends Record<string, T>>(
  packages: P
): T {
  const lowestPackageType = Object.entries(packages).reduce(
    (lowestPackage: string, [packageType, packageConfig]: [string, T]) => {
      if (!lowestPackage) {
        return packageType;
      }

      if (
        packageConfig.available &&
        prioritizer.getPriority(packageType as SubscriptionType) <
          prioritizer.getPriority(lowestPackage as SubscriptionType)
      ) {
        return packageType;
      }

      return lowestPackage;
    },
    ''
  );

  return packages[lowestPackageType];
}

export default getLowestPackage;
